export const SITE_NAME = "Elite Herbalist";
const DEFAULT_DESC = "Free AI-powered herbal assessment with personalised herb recommendations, safety guidance and a UK herb store. Backed by science, guided by ancient wisdom.";

export const setPageMeta = (title, description) => {
  document.title = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} — Free AI Herbal Assessment & Personalised Wellness Plans`;
  let meta = document.querySelector('meta[name="description"]');
  if (!meta) {
    meta = document.createElement("meta");
    meta.setAttribute("name", "description");
    document.head.appendChild(meta);
  }
  meta.setAttribute("content", description || DEFAULT_DESC);
  let canonical = document.querySelector('link[rel="canonical"]');
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }
  canonical.setAttribute("href", `https://eliteherbalist.com${window.location.pathname}`);
};

export const setJsonLd = (id, data) => {
  document.querySelectorAll(`script[data-jsonld="${id}"]`).forEach((s) => s.remove());
  if (!data) return;
  const script = document.createElement("script");
  script.type = "application/ld+json";
  script.setAttribute("data-jsonld", id);
  script.textContent = JSON.stringify(data);
  document.head.appendChild(script);
};

export const faqSchema = (faq) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faq.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});

export const ROUTE_META = {
  "/": { title: null, desc: DEFAULT_DESC },
  "/questionnaire": { title: "Free AI Herbal Assessment", desc: "Answer a few quick questions and get personalised educational herbal recommendations in under 2 minutes. Free and AI-powered." },
  "/recommendations": { title: "Your Personalised Wellness Plan", desc: "Your AI-generated herbal wellness plan with recommended herbs, dosages, recipes and safety guidance." },
  "/herbs": { title: "Herb Encyclopedia — 95+ Medicinal Herbs", desc: "Browse our encyclopedia of 95+ medicinal herbs with benefits, uses, dosages and safety precautions for each botanical." },
  "/news": { title: "Daily Herbal Wellness News", desc: "Daily curated news and insights from the world of herbal medicine and natural wellness." },
  "/store": { title: "The Herb Store — Buy Real Botanicals Online UK", desc: "Shop 95+ real botanicals with UK delivery from £1.99. Protocol bundles, secure Stripe checkout, typically ships in 3–7 working days." },
  "/white-label": { title: "White-Label AI Herbal Assessment for Stores", desc: "Give your customers a personalised herbal wellness assessment — branded to your store, mapped to your shelves. Free pilot: no setup fee or monthly subscription." },
  "/white-label/pricing": { title: "White-Label Pricing — Free Revenue-Share Pilot", desc: "No setup fee, no monthly subscription. Elite Herbalist receives 5% of eligible sales attributed to the assessment." },
  "/white-label/how-it-works": { title: "How White-Label Setup Works for Stores", desc: "From sign-up to live assessment in under a week. Seven simple steps — we handle the technical side, you send the logo." },
  "/white-label/faq": { title: "White-Label FAQs for Store Owners", desc: "Answers for store owners: setup time, custom domains, customer data ownership, cancellation, custom catalogues and more." },
  "/shop": { title: "Shop Infuso — Carbonation Equipment & Fruit Teas", desc: "Everything you need to create sparkling herbal beverages at home, plus premium organic fruit teas from Infuso." },
  "/cart": { title: "Your Cart", desc: "Review your selected herbs and bundles, then check out securely with Stripe." },
  "/account": { title: "My Account", desc: "Manage your Elite Herbalist subscription, orders and assessment progress." },
  "/mens-vitality-guide": { title: "Men's Vitality Guide — Herbal Protocols for Energy", desc: "Evidence-informed herbal protocols to support men's energy, stress resilience and hormonal health." },
  "/mens-maintenance-guide": { title: "Men's Maintenance Guide", desc: "Keep your vitality gains with this herbal maintenance guide for men." },
  "/womens-hormone-guide": { title: "Women's Hormone Guide — Herbal Support for Balance", desc: "Herbal protocols to support women's hormonal harmony, mood and cycle health." },
  "/womens-balance-guide": { title: "Women's Balance Guide", desc: "Maintain hormonal balance naturally with this herbal guide for women." },
  "/mens-vitality-protocol": { title: "Men's Vitality Protocol Bundle", desc: "The complete 7-herb stack for energy, stress resilience and hormonal support — save 10% as a bundle." },
  "/womens-balance-protocol": { title: "Women's Balance Protocol Bundle", desc: "The complete 5-herb stack for hormonal harmony, mood and cycle support — save 10% as a bundle." },
  "/mens-scorecard": { title: "Men's Vitality Check", desc: "Premium 2-minute vitality self-check for men: stamina, stress, sleep and energy scoring." },
  "/womens-assessment": { title: "Women's Hormone Assessment", desc: "Premium 2-minute hormone self-check for women: mood, energy, sleep and balance scoring." },
};
